import { createSlice } from '@reduxjs/toolkit'
import { deleteOriginalUser, setData, setOriginalUser, setRoles } from '../reducers/userReducers'

type UserState = {
  userName: string
  userId: string
  roles: string[]
  originalUser?: {
    userId: string
    userName: string
  }
}

const initialState: UserState = {
  userName: '',
  userId: '',
  roles: [],
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setData,
    setRoles,
    setOriginalUser,
    deleteOriginalUser,
  },
})

export type { UserState }
export const userActions = userSlice.actions
export default userSlice.reducer
